import local from "./config.local.json";
import dev from "./config.dev.json";
import prod from "./config.prod.json";
import test from "./config.test.json";

const env = (process.env.REACT_APP_ENV || "").toLowerCase();

const byEnv = {
  local,
  dev,
  prod,
  test,
};

function pickConfig() {
  if (env && byEnv[env]) return byEnv[env];
  if (process.env.NODE_ENV === "production") return prod;
  if (process.env.NODE_ENV === "test") return test;
  return local;
}

const config = pickConfig();
export default config;